/** @format */

import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from '@components/loader';
import { TranslationProvider } from '@context/translation-context';

const NewsroomSubscribe = lazy(
  () =>
    import(/* webpackChunkName: "newsroom-subscribe" */ './newsroom-subscribe')
);
const RecentNews = lazy(
  () => import(/* webpackChunkName: "recent-news" */ './recent-news')
);

/**
 * Build Image Gallery.
 */
export const newsroomSidebar = () => {
  const sideboxes = document.querySelectorAll('.newsroom-side-boxes');
  const sideBoxType = (sidebox) => {
    if (!sidebox.dataset.category) {
      return null;
    }
    const [boxType, formType] = sidebox.dataset.category.split(' ');
    switch (boxType) {
      case 'subscribe':
        return <NewsroomSubscribe formType={formType} />;
      case 'news':
        return <RecentNews />;
      default:
        return <></>;
    }
  };

  if (sideboxes) {
    {
      sideboxes.forEach((sidebox, index) => {
        const root = createRoot(sideboxes[index]);
        root.render(
          <Suspense fallback={<Loader />}>
            <TranslationProvider>{sideBoxType(sidebox)}</TranslationProvider>
          </Suspense>
        );
      });
    }
  }
};
